export const dimensions = () => `${window.innerWidth}x${window.innerHeight}`;
export const orientation = () =>
  window.innerHeight > window.innerWidth ? 'Vertical' : 'Horizontal';
